import { IBillingContacts } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

export const ownershipGroupRelationAlias = 'og';
export const clientHasBillingContactsAlias = 'chbc';
export const defaultFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'clientHasBillingContacts',
      alias: clientHasBillingContactsAlias,
    },
    {
      path: 'chbc.ownershipGroup',
      alias: ownershipGroupRelationAlias,
    },
  ],
};

const adminGatewayResourcePath: string = '/client-api/billing_contacts';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = defaultFilters;
const defaultGetSingleFilters: IQueryCommandOptions = defaultFilters;
const base = new StoreBaseImplementationV2<IBillingContacts>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
